var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8317H5.00002C4.77901 10.8317 4.56705 10.7439 4.41076 10.5876C4.25448 10.4313 4.16669 10.2194 4.16669 9.99837C4.16669 9.77736 4.25448 9.5654 4.41076 9.40912C4.56705 9.25284 4.77901 9.16504 5.00002 9.16504H15C15.221 9.16504 15.433 9.25284 15.5893 9.40912C15.7456 9.5654 15.8334 9.77736 15.8334 9.99837C15.8334 10.2194 15.7456 10.4313 15.5893 10.5876C15.433 10.7439 15.221 10.8317 15 10.8317Z",
    fill: "white",
    fillOpacity: 0.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.7d6947d5c72a3053dbb53ee52f32bb51.svg";
export { ForwardRef as ReactComponent };